exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  margin-top: 0;\n}\n\n.input-row {\n  margin-top: 20px;\n}\n\n.dropdown-label {\n  padding-top: 7px;\n  text-align: center;\n}\n\n.datepicker-label {\n  padding-top: 7px;\n  text-align: center;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/export/export.component.css
// module id = ../../../../../src/app/modules/export/export.component.css
// module chunks = main